class ConsoleEvent {
  static SESSION_OPENED = 'ConsoleEvent.SESSION_OPENED';

  static SESSION_CLOSED = 'ConsoleEvent.SESSION_CLOSED';

  static FOCUS_HISTORY = 'ConsoleEvent.FOCUS_HISTORY';

  static SEND_COMMAND = 'ConsoleEvent.SEND_COMMAND';

  static SETTINGS_CHANGED = 'ConsoleEvent.SETTINGS_CHANGED';
}

export default ConsoleEvent;
